<template>
    <div>
        <div
            v-if="isLoading"
            key="loadingContent"
            class="my-8 px-4 flex justify-center"
        >
            <Spinners />
        </div>
        <div
            v-else
            v-for="(swimLane, idx) in swimLanesToLoad"
            :key="idx"
            class="mb-16"
        >
            <h3 class="mb-8">
                {{ swimLane.headerLabel }}
            </h3>

            <div class="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
                <component
                    :is="attendeeCard"
                    v-for="(attendee, idx) in attendeesSwimLane[
                        `${swimLane.name.trim()}`
                    ]"
                    :key="idx"
                    class="py-6 bg-card shadow rounded-xl flex flex-col items-center transition-shadow duration-500 ease-in-out hover:shadow-2xl"
                    layout="column"
                    :title="attendee.title"
                    :name="attendee.firstName + ' ' + attendee.lastName"
                    :nameInitial="attendee.firstName[0] + attendee.lastName[0]"
                    :companyName="attendee.companyName"
                    :imgPath="attendee.imgPath"
                    :hasFullDetail="false"
                    :id="attendee.attendeeId"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store/index.ts";

import featuredAttendeeVuexModule from "@/store/vuex-modules/getFeaturedAttendees";

import Spinners from "@/components/utilities/Spinners.vue";

const featuredAttendeeStore = getModule(featuredAttendeeVuexModule);

@Component({
    computed: {
        ...mapGetters(["awsConfig"])
    },
    components: {
        Spinners,
        "attendee-card": () => {
            let returnResult = store.getters.getPageOptions("attendees")
                .attendeeCardLayout;
            if (!returnResult) {
                returnResult = "AttendeeCard.vue";
            }
            return import(`@/components/shared/${returnResult}`);
        }
    }
})
export default class AttendeesTaxonomySwimlane extends Vue {
    isLoading = true;
    isOwnDataLoaded = false;
    attendeeCard = "attendee-card";
    id = "";

    get swimLanesToLoad() {
        return this.$store.getters.getPageOptions("attendees").swimLanes;
    }

    get attendeesSwimLane() {
        return featuredAttendeeStore.featuredAttendeeByType;
    }

    async created() {
        await featuredAttendeeStore.getFeaturedAttendeeByType(true).then(() => {
            this.isLoading = false;
        });
    }

    getFullPath() {
        const isDemoData = !this.$store.getters.awsConfig.attendeeTable;
        if (isDemoData)
            return `https://vmpstore.s3.amazonaws.com/images/attendees/${this.imgPath}`;
        else
            return this.imgPath
                ? this.imgPath
                : require("../../../assets/avatar.png");
    }
}
</script>
